<template>
    <div>
      <trademark-publication-type-list></trademark-publication-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  